import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateNormalizedFile } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractNormalizedFileUpload = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateNormalizedFile,
        onSuccess: (_, { contractId }) =>
            queryClient.invalidateQueries({ queryKey: queries.contracts.detail(contractId).queryKey }),
    });
};
